import * as gridSettings from '@/app/gridGL/pixiApp/gridSettings';

const isAIAnalystFocused = (): boolean => {
  return document.activeElement?.closest('[data-ai-analyst-panel]') !== null;
};

const isInlineEditorFocused = (): boolean => {
  // Check if focus is in the Monaco editor's cell-edit container or any of its children
  const activeElement = document.activeElement;
  if (!activeElement) return false;

  // Check for the cell-edit container (Monaco editor's parent)
  if (activeElement.closest('#cell-edit')) return true;

  // Also check for Monaco's internal input elements (textarea used for input)
  if (activeElement.tagName === 'TEXTAREA' && activeElement.closest('.monaco-editor')) return true;

  return false;
};

export const focusGrid = () => {
  // Don't steal focus from AI Analyst panel
  if (isAIAnalystFocused()) {
    return;
  }

  // Don't steal focus from inline editor (check both the state and actual DOM focus)
  if (gridSettings.getInput().show || gridSettings.isEditingPending() || isInlineEditorFocused()) {
    return;
  }

  const editorInteractionState = gridSettings.getEditorInteractionState();
  const modalShow =
    editorInteractionState.showCellTypeMenu ||
    editorInteractionState.showCommandPalette ||
    editorInteractionState.showConnectionsMenu ||
    editorInteractionState.showGoToMenu ||
    editorInteractionState.showFeedbackMenu ||
    editorInteractionState.showRenameFileMenu ||
    editorInteractionState.showShareFileMenu ||
    editorInteractionState.showSearch ||
    editorInteractionState.showContextMenu;
  if (modalShow) {
    return;
  }

  // Set focus back to Grid
  const grid = document.querySelector<HTMLCanvasElement>('.pixi_canvas');
  if (grid) {
    grid.focus();
  }
};

export const focusAIAnalyst = () => {
  const textarea = document.querySelector<HTMLTextAreaElement>('[data-ai-analyst-input]');
  if (textarea) {
    textarea.focus();
    return;
  }

  // Element not yet in DOM — poll using rAF with a timeout
  const maxWaitMs = 2000;
  const start = performance.now();

  const poll = () => {
    const el = document.querySelector<HTMLTextAreaElement>('[data-ai-analyst-input]');
    if (el) {
      el.focus();
      return;
    }
    if (performance.now() - start < maxWaitMs) {
      requestAnimationFrame(poll);
    }
  };

  requestAnimationFrame(poll);
};
